import { HiOutlineCog, HiOutlineBell, HiOutlineExternalLink, HiOutlineCheckCircle } from 'react-icons/hi'
import { FaTelegramPlane } from 'react-icons/fa'
import { Link } from 'react-router-dom'
// Browser Push Notification - TEMPORARILY HIDDEN
// import NotificationToggle from '../components/common/NotificationToggle'

const TELEGRAM_CHANNEL_URL = 'https://t.me/+FzvKdNbv_rZiMjI1'

function Settings() {
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <HiOutlineCog className="w-7 h-7 text-gray-500" />
          Cài đặt
        </h1>
        <p className="text-gray-500 mt-1">Quản lý các tùy chọn ứng dụng</p>
      </div>

      {/* Notification Settings Section */}
      <div className="space-y-4">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <HiOutlineBell className="w-5 h-5 text-gray-400" />
          Cài đặt thông báo
        </h2>
        <p className="text-sm text-gray-600">
          Nhận thông báo khi có tin tức BĐS mới qua Telegram Channel.
        </p>

        {/* Telegram Channel */}
        <div className="card overflow-hidden">
          <div className="p-5 border-b border-gray-100 bg-gradient-to-r from-sky-50 to-blue-50">
            <div className="flex items-start gap-4">
              <div className="p-3 rounded-xl bg-sky-500 text-white flex-shrink-0">
                <FaTelegramPlane className="w-6 h-6" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-semibold text-gray-900">Telegram Channel</h3>
                  <span className="px-2 py-0.5 text-xs font-medium bg-sky-100 text-sky-700 rounded-full">
                    Khuyên dùng
                  </span>
                </div>
                <p className="text-sm text-gray-600">
                  Nhận tin tức qua Telegram Bot - hoạt động trên mọi thiết bị, kể cả khi tắt trình duyệt
                </p>
              </div>
            </div>
          </div>

          <div className="p-5 space-y-4">
            {/* Benefits */}
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <HiOutlineCheckCircle className="w-4 h-4 text-green-500 flex-shrink-0" />
                <span>Nhận thông báo trên điện thoại và máy tính</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <HiOutlineCheckCircle className="w-4 h-4 text-green-500 flex-shrink-0" />
                <span>Hoạt động 24/7, không cần mở trình duyệt</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <HiOutlineCheckCircle className="w-4 h-4 text-green-500 flex-shrink-0" />
                <span>Lịch sử tin nhắn được lưu trữ</span>
              </div>
            </div>

            {/* Actions */}
            <div className="flex flex-wrap items-center gap-3 pt-2">
              <a
                href={TELEGRAM_CHANNEL_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-sky-500 text-white font-medium text-sm hover:bg-sky-600 transition-colors shadow-sm"
              >
                <FaTelegramPlane className="w-4 h-4" />
                <span>Tham gia Channel</span>
                <HiOutlineExternalLink className="w-4 h-4" />
              </a>
              <Link
                to="/settings/telegram"
                className="text-sm text-sky-600 hover:text-sky-700 hover:underline"
              >
                Xem hướng dẫn chi tiết →
              </Link>
            </div>
          </div>
        </div>

        {/* TEMPORARILY HIDDEN - Browser Push Notification
        <div className="card overflow-hidden">
          <div className="p-5 border-b border-gray-100 bg-gradient-to-r from-purple-50 to-indigo-50">
            <div className="flex items-start gap-4">
              <div className="p-3 rounded-xl bg-purple-500 text-white flex-shrink-0">
                <HiOutlineBell className="w-6 h-6" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-gray-900 mb-1">Thông báo trình duyệt</h3>
                <p className="text-sm text-gray-600">
                  Nhận push notification trực tiếp trên trình duyệt khi đang online
                </p>
              </div>
            </div>
          </div>

          <div className="p-5 space-y-4">
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <HiOutlineCheckCircle className="w-4 h-4 text-green-500 flex-shrink-0" />
                <span>Thông báo xuất hiện ngay trên màn hình</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <HiOutlineCheckCircle className="w-4 h-4 text-green-500 flex-shrink-0" />
                <span>Không cần cài đặt thêm ứng dụng</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <HiOutlineCheckCircle className="w-4 h-4 text-gray-400 flex-shrink-0" />
                <span className="text-gray-500">Yêu cầu trình duyệt mở (background)</span>
              </div>
            </div>

            <div className="pt-2">
              <NotificationToggle variant="default" />
            </div>
          </div>
        </div>
        */}
      </div>
    </div>
  )
}

export default Settings
